import React, { useState } from 'react';
import { Calendar, List } from 'lucide-react';
import BookingsList from '../../components/admin/bookings/BookingsList';
import BookingsCalendar from '../../components/admin/bookings/BookingsCalendar';
import './AdminBookings.css';

const AdminBookings = () => {
  const [view, setView] = useState('list'); // 'list' or 'calendar'

  return (
    <div className="admin-bookings-page">
      <div className="admin-page-header">
        <h1 className="admin-page-title">Bookings</h1>
        <div className="view-toggle">
          <button
            className={`view-toggle-btn ${view === 'list' ? 'active' : ''}`}
            onClick={() => setView('list')}
          >
            <List size={18} />
            List View
          </button>
          <button
            className={`view-toggle-btn ${view === 'calendar' ? 'active' : ''}`}
            onClick={() => setView('calendar')}
          >
            <Calendar size={18} />
            Calendar View
          </button>
        </div>
      </div>

      {view === 'list' ? <BookingsList /> : <BookingsCalendar />}
    </div>
  );
};

export default AdminBookings;